import React, {Fragment} from 'react';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import Aqp from '../../../../libs/mk-react-aqp';

import {fetchForumChildrens, resetForumChildrens} from "../../../../creators/forums.children";
import {fetchForumTopics, resetForumTopics} from "../../../../creators/forums.topics";

import CardCategory from "./CardCategory";
import ContentLoader from "react-content-loader"
import CardTopics from "./CardTopics";
import Pagination from "../../../components/Pagination";
import ToplineCategory from "./ToplineCategory";
import {LoadingBar} from "../../../components/Loader";
import _ from 'lodash';
import createLink from "../../../../libs/createLink";
import {fetchForumBreadcrumbs, resetForumBreadcrumbs} from "../../../../creators/forums.breadcrumbs";
import {config} from "../../../../config";
import {canonical} from "../../../../libs/helper";
import Helmet from "react-helmet";

let mapping = {
    //TODO : revoir il remplace pour la query avec les bonnes valeurs mais rajoute des & dans l'url
    'owner.profile.gender': 'gender',
};

class ForumChildrens extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            limit: 20,
            page: 1,
            sort: 0,
            "owner.profile.gender": [],
            parentSlug : this.props.match.params.slugParent
        };

        // let category = this.props.match.params.slugParent ?
        //     {categoryParent : {slug : this.props.match.params.slugParent}, category : {slug : this.props.match.params.slug, _id : this.props.match.params.forumId}} :
        //     {category : {slug : this.props.match.params.slug, _id : this.props.match.params.forumId}};

        let category = this.props.match.params.slugParent ?
            {categoryParent : {slug : this.props.match.params.slugParent}, category : {slug : this.props.match.params.slug, _id : this.props.match.params.forumId}} :
            {category : {slug : this.props.match.params.slug, _id : this.props.match.params.forumId}};
        this.aqp = new Aqp(mapping, {
            blacklist: ['limit', 'page', 'parentSlug'],
            currentLink: createLink("forumCategory", category),
            filterDefault: this.filter
        });

        // this.query = queryString.parse(this.props.location.search);

        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: this.props.match.params.page || 1}
        };
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleFilterSort = this.handleFilterSort.bind(this);
        this.handleGender = this.handleGender.bind(this);
        this.reloadChildrens = this.reloadChildrens.bind(this);

        if(this.props.match.params.slugParent && this.props.match.params.slug){
            this.props.fetchForumChildrens(this.props.match.params.slug, {slugParent : this.props.match.params.slugParent});
        }
        else{
            this.props.fetchForumChildrens(this.props.match.params.slugParent || this.props.match.params.slug);
        }

        this.fetchForumTopics(this.state.filter);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentDidUpdate(prevProps) {
        if(this.props.forumChildrens !== prevProps.forumChildrens){
            this.props.fetchForumBreadcrumbs(this.props.match.params.slug, {slugParent : this.props.match.params.slugParent || null});
        }
        if (this.props.match.params.slug !== prevProps.match.params.slug || this.props.match.params.slugParent !== prevProps.match.params.slugParent) {
            let newCategory = this.props.match.params.slugParent ?
                {categoryParent : {slug : this.props.match.params.slugParent}, category : {slug : this.props.match.params.slug, _id : this.props.match.params.forumId}} :
                {category : {slug : this.props.match.params.slug, _id : this.props.match.params.forumId}};

            this.aqp.setCurrentLink(createLink("forumCategory", newCategory));
            this.props.resetForumChildrens();
            this.props.resetForumTopics();
            if(this.props.match.params.slugParent && this.props.match.params.slug){
                this.props.fetchForumChildrens(this.props.match.params.slug, {slugParent : this.props.match.params.slugParent});
            }
            else{
                this.props.fetchForumChildrens(this.props.match.params.slugParent || this.props.match.params.slug);
            }
            this.setState({filter : {...this.state.filter, page : 1}}, () => this.fetchForumTopics(this.state.filter));
        }
    }

    reloadChildrens() {
        // this.props.resetForumChildrens();
        // this.props.resetForumTopics();
        // this.props.fetchForumChildrens(this.props.match.params.slug);
        // this.fetchForumTopics(this.state.filter);
    }

    componentWillUnmount() {
        this.props.resetForumChildrens();
        this.props.resetForumTopics();
        this.aqp.setCurrentLink("");
    }

    handleChangePage(page) {
        let filter = {...this.state.filter, page};
        this.setState({filter});
        this.fetchForumTopics(filter);
        window.scrollTo(0, 0);
    }

    fetchForumTopics(filter) {
        let query = {...filter};
        this.props.fetchForumTopics(this.props.match.params.slug, this.aqp.set(query))
    }

    handleFilterSort(value) {
        let filter = {...this.state.filter, sort: value, page: 1};
        this.setState({filter}, () => this.fetchForumTopics(filter));
    }

    handleGender(value) {
        let tags = this.state.filter["owner.profile.gender"];

        if(Array.isArray(tags)){
            tags = [...tags];
        }else if(tags){
            tags = [tags];
        }
        let newTags = [...tags];


        if (!tags.includes(value)) {
            newTags.push(value);
        } else {
            newTags = tags.filter(item => value !== item);
        }

        let filter = {...this.state.filter, "owner.profile.gender": newTags, page: 1};

        this.setState({filter}, () => this.fetchForumTopics(filter));
    }

    // shouldComponentUpdate(nextProps, nextState, nextContext) {
    //     if(this.state !== nextState){
    //         return true;
    //     }
    //     if((this.props.forumChildrensInitialized !== nextProps.forumChildrensInitialized || this.props.forumTopicsInitialized !== nextProps.forumTopicsInitialized)){
    //         return true;
    //     }
    //     if(this.props.breadcrumbsInitialized !== nextProps.breadcrumbsInitialized || this.props.breadcrumbs !== nextProps.breadcrumbs){
    //         return true;
    //     }
    //     if(this.props.forumChildrensInitialized || this.props.forumTopicsInitialized){
    //         if(this.props.forumChildrensLoading !== nextProps.forumChildrensLoading || this.props.forumTopicsLoading !== nextProps.forumTopicsLoading){
    //             return true;
    //         }
    //     }
    //
    //     if(this.props.forumTopicsTotal !== nextProps.forumTopicsTotal){
    //         return true;
    //     }
    //     if(this.props.match.params.slug !== nextProps.match.params.slug || this.props.match.params.slugParent !== nextProps.match.params.slugParent){
    //         return true;
    //     }
    //     return false;
    // }

    render() {

        let {childrens = []} = this.props.forumChildrens;
        let currentForum = {
          name : "",
          description : "",
          _id : null,
          slug : ""
        };
        if(this.props.forumTopics && this.props.forumTopics.length){
            let forum = _.get(this.props.forumTopics, "[0].forum");
            if(!(forum && forum.name)){
                //window.reload();
                window.location.reload();
            }
            if(forum){
                currentForum = {
                    name : forum.name || "",
                    description : forum.description || "",
                    _id : forum._id || "",
                    slug : forum.slug || ""
                };
            }
        }
        else if(childrens && childrens.length){
            let forumChildrens = _.get(this.props.forumChildrens);
            if(forumChildrens){
                currentForum = {
                    name : forumChildrens.name,
                    description : forumChildrens.description,
                    _id : forumChildrens._id,
                    slug : forumChildrens.slug
                };
            }
        }
        // let categoryParent = (this.props.match.params.slug && this.props.breadcrumbs && this.props.breadcrumbs[1] && this.props.breadcrumbs[1].slug) || "" ;

        let totalPage = Math.ceil((this.props.forumChildrensTotal || this.props.forumTopicsTotal) / this.state.filter.limit);

        let url = this.aqp.queryUrl(this.state.filter, mapping);
        let currentPage = parseInt(this.state.filter.page);

        return (!this.props.forumChildrensInitialized || (!this.props.forumTopicsInitialized && this.props.match.params.slugParent)) ? (
            <div className="p-16">
                {_.times(10).map((item, index) => (
                    <ContentLoader
                        key={index}
                        height={38}
                        width={800}
                        speed={2}
                        ariaLabel={false}
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <circle cx="22.5" cy="18.29" r="16.5"/>
                        <rect x="50.56" y="18.61" rx="4" ry="4" width="161" height="5"/>
                        <rect x="504.56" y="13.61" rx="4" ry="4" width="65" height="5"/>
                        <rect x="497.56" y="23.61" rx="4" ry="4" width="73" height="5"/>
                        <circle cx="597.35" cy="19.4" r="13.79"/>
                        <rect x="665.56" y="6.61" rx="4" ry="4" width="124" height="5"/>
                        <rect x="667.56" y="17.61" rx="4" ry="4" width="122" height="5"/>
                        <rect x="665.56" y="28.61" rx="4" ry="4" width="125" height="5"/>
                    </ContentLoader>
                ))}
            </div>
        ) : (
            <Fragment>
                <Helmet>
                    <title>{config.preTitle}{currentForum.name}{config.postTitle} {currentPage >1 ? `( page ${currentPage} )` : ""}</title>
                    <meta name="description" content={currentForum.description}/>
                    {currentPage === 2 && (<link rel="prev" href={canonical(url.link, url.search, "forumCategory") }/>)}
                    {currentPage >= 3 && (<link rel="prev" href={canonical(`${url.link}/${(currentPage - 1)}`, url.search, "forumCategory")} />)}
                    <link rel="canonical" href={currentPage >1 ? canonical(`${url.link}/${currentPage}`, url.search, "forumCategory") : canonical(url.link, url.search, "forumCategory")} />
                    {currentPage < totalPage && (<link rel="next" href={canonical(`${url.link}/${(currentPage +1)}`, url.search, "forumCategory")} />)}
                </Helmet>
                <ToplineCategory
                    currentUser={this.props.currentUser}
                    currentUserInitialized={this.props.currentUserInitialized}
                    handleFilterSort={this.handleFilterSort}
                    filter={this.state.filter}
                    handleGender={this.handleGender}
                    {...this.props} />
                {(this.props.forumChildrensLoading || this.props.forumTopicsLoading)  && (
                    <LoadingBar />
                )}
                {childrens.length >= 1 && (this.props.forumTopics.length === 0 || this.props.match.params.slug === "sexualite") &&
                    childrens.map((childrens, childrensIndex) => (
                        <CardCategory
                            {...childrens}
                            forumChildrens={this.props.forumChildrens}
                            currentUser={this.props.currentUser}
                            key={childrensIndex}
                            match={this.props.match}
                            breadcrumbs={this.props.breadcrumbs}
                        />
                    ))
                }
                {this.props.forumTopics.length >= 1 && this.props.match.params.slug !== "sexualite" &&
                    this.props.forumTopics.map((topic, topicIndex) => (
                        <CardTopics
                            {...topic}
                            currentUser={this.props.currentUser}
                            reloadChildrens={this.reloadChildrens}
                            key={topicIndex}
                            match={this.props.match}
                        />
                    ))
                }
                {totalPage > 1 && (!this.props.forumChildrensLoading || !this.props.forumTopicsLoading) && (
                    <div className={`pagination-wrapper`}>
                        <Pagination currentPage={this.state.filter.page}
                                    pagesCount={totalPage}
                                    {...this.aqp.queryUrl(this.state.filter, mapping)}
                                    handleChangePage={this.handleChangePage}/>
                    </div>
                )}
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {

    return {
        currentUser: state.currentUser.data,
        currentUserInitialized: state.currentUser.initialized,

        forumChildrens: state.forumChildrens.data,
        forumChildrensLoading: state.forumChildrens.loading,
        forumChildrensInitialized: state.forumChildrens.initialized,
        forumChildrensTotal: state.forumChildrens.total,

        forumTopics: state.forumTopics.data,
        forumTopicsLoading: state.forumTopics.loading,
        forumTopicsInitialized: state.forumTopics.initialized,
        forumTopicsTotal: state.forumTopics.total,
        breadcrumbs : state.forumBreadcrumbs.data,
        breadcrumbsInitialized: state.forumBreadcrumbs.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchForumChildrens,
    resetForumChildrens,
    fetchForumTopics,
    resetForumTopics,
    fetchForumBreadcrumbs,
    resetForumBreadcrumbs,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForumChildrens);
